var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "title typographies-heading-h2" }, [
      _vm._v(_vm._s(_vm.$l10n.__("Critères de comparaison")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "subtitle typographies-paragraph-medium-regular" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.getTypeImport.comparisonCriteriaDescription) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "identifier-option__container" },
      _vm._l(_vm.identifiers, function(identifier, key) {
        return _c(
          "div",
          { key: key, staticClass: "identifier-option__item" },
          [
            _c(
              "div",
              { staticClass: "identifier-title" },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(identifier.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      "content-class": "tooltip-import-options",
                      placement: "bottom-start"
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      _vm._l(identifier.choices, function(choice) {
                        return _c("div", { key: choice.value }, [
                          _c("h4", { staticClass: "typographies-heading-h4" }, [
                            _vm._v(_vm._s(choice.label))
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "typographies-paragraph-small-semibold"
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(choice.description) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("CompassIcon", {
                      attrs: { icon: "info-circle-fill", size: "small" }
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            identifier.multiple
              ? _c(
                  "div",
                  { staticClass: "identifier-content" },
                  [
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          error: _vm.errorMsgSelect(
                            _vm.identifiersSelected[key]
                          ),
                          label: ""
                        }
                      },
                      [
                        _c(
                          "CompassSelect",
                          {
                            attrs: {
                              error:
                                _vm.errorMsgSelect(_vm.identifiersSelected[key])
                                  .length > 0,
                              multiple: "",
                              "menu-class": "menu-import-dialog"
                            },
                            model: {
                              value: _vm.identifiersSelected[key],
                              callback: function($$v) {
                                _vm.$set(_vm.identifiersSelected, key, $$v)
                              },
                              expression: "identifiersSelected[key]"
                            }
                          },
                          _vm._l(identifier.choices, function(
                            choice,
                            keyChoice
                          ) {
                            return _c(
                              "CompassDropdownSelectOption",
                              _vm._b(
                                {
                                  key: keyChoice,
                                  attrs: { type: "checkbox" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                "CompassDropdownSelectOption",
                                choice,
                                false
                              )
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "CompassRadioGroup",
                  {
                    attrs: { direction: "horizontal" },
                    model: {
                      value: _vm.identifiersSelected[key][0],
                      callback: function($$v) {
                        _vm.$set(_vm.identifiersSelected[key], 0, $$v)
                      },
                      expression: "identifiersSelected[key][0]"
                    }
                  },
                  _vm._l(identifier.choices, function(choice, keyChoice) {
                    return _c("CompassRadio", {
                      key: choice.value,
                      attrs: {
                        checked: _vm.isSelected(choice, keyChoice),
                        label: choice.label,
                        "model-value": choice.value,
                        size: "medium"
                      }
                    })
                  }),
                  1
                )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }